import React, { memo } from 'react';
import ReactPlayer from 'react-player/youtube';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { WeddingCeremonySection } from '../components/WeddingCeremonySection';
import { WeddingReceptionSection } from '../components/WeddingReceptionSection';
import { RealLoveStoriesSection } from '../components/RealLoveStoriesSection';
import { WeddingBookingSection } from '../components/WeddingBookingSection';
import { WeddingPackagesSection } from '../components/WeddingPackagesSection';
import { ChevronRight, CalendarIcon } from 'lucide-react';
export function WeddingsPage() {
  return <div className="min-h-screen bg-white" data-id="element-1749">
      {/* Header */}
      <Header variant="light" data-id="element-1750" />

      {/* Hero Section with Video */}
      <section className="relative min-h-[80vh] overflow-hidden pt-32" data-id="element-1751">
        {/* YouTube Video Background */}
        <div className="absolute inset-0 w-full h-full overflow-hidden z-0" data-id="element-1752">
          <ReactPlayer url="https://www.youtube.com/watch?v=iXGJ4JDz638" playing loop muted width="100%" height="100%" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" style={{
          minWidth: '177.77vh',
          minHeight: '56.25vw',
          pointerEvents: 'none'
        }} config={{
          youtube: {
            playerVars: {
              autoplay: 1,
              controls: 0,
              rel: 0,
              showinfo: 0,
              mute: 1,
              loop: 1,
              playlist: 'iXGJ4JDz638',
              modestbranding: 1,
              playsinline: 1
            }
          }
        }} data-id="element-1753" />
        </div>

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/50 z-10" data-id="element-1754" />

        {/* Content */}
        <div className="max-w-4xl mx-auto text-center relative z-20 px-6 sm:px-8 h-full flex flex-col justify-center py-20" data-id="element-1755">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-1756" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-1757">
            Celebrations
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-6 leading-tight" data-id="element-1758">
            Weddings & Events
          </h1>
          <p className="text-xl text-white mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-1759">
            Create unforgettable memories at our picturesque vineyard. Our
            stunning venue offers breathtaking views and exceptional service for
            your special day.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-1760">
            <a href="#booking" className="inline-flex items-center gap-2 bg-white text-brand-grey px-8 py-3 hover:bg-neutral-100 transition-colors font-medium rounded-none group" onClick={e => {
            e.preventDefault();
            document.getElementById('booking')?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }} data-id="element-1761">
              <CalendarIcon size={18} data-id="element-1762" />
              Book a Tour
              <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1763" />
            </a>
            <a href="#packages" className="inline-flex items-center gap-2 px-8 py-3 border-2 border-white text-white hover:bg-white hover:text-brand-grey transition-colors font-medium rounded-none group" onClick={e => {
            e.preventDefault();
            document.getElementById('packages')?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }} data-id="element-1764">
              View Packages
              <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1765" />
            </a>
          </div>
        </div>
      </section>

      {/* Corporate Events & Funerals Banner */}
      <div className="relative z-30 -mt-24" data-id="element-1766">
        <div className="max-w-4xl mx-auto px-6 sm:px-8" data-id="element-1767">
          <div className="bg-neutral-900 px-10 py-8 text-center" data-id="element-1768">
            <p className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-3" data-id="element-1769">
              Also Available
            </p>
            <p className="font-heading text-2xl text-white mb-4" data-id="element-1770">
              Corporate Events & Funerals and Wakes
            </p>
            <Link to="/contact" className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-1771">
              Contact Us
              <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1772" />
            </Link>
          </div>
        </div>
      </div>

      {/* Ceremony Section */}
      <WeddingCeremonySection data-id="element-1773" />

      {/* Reception Section */}
      <WeddingReceptionSection data-id="element-1774" />

      {/* Wedding Packages Showcase */}
      <WeddingPackagesSection data-id="element-1775" />

      {/* Real Love Stories */}
      <RealLoveStoriesSection data-id="element-1776" />

      {/* Booking Form Section */}
      <WeddingBookingSection data-id="element-1777" />

      {/* Footer */}
      <Footer data-id="element-1778" />
    </div>;
}